'use client'

import React from 'react'
import { useRegionFaqs } from '../../../RegionContent'
import styles from './styles.module.css'
import { $neutralGray50 } from '../../../../styles/colors/primitives'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CtaV2 from '../../../CtaV2'
import FaqCollapsibleList from '../../FaqCollapsibleList'
import { buildFaqJsonLd, getFaqsForJsonLd } from './faqJsonLd'

// App-Router-safe FAQ JSON-LD. next-seo's <FAQPageJsonLd> renders through
// next/head, whose useContext(HeadManagerContext) returns null under App Router
// SSR — it THROWS and drops the structured data from the SSR HTML. We emit the
// SAME schema.org @graph next-seo would build as a raw
// <script type="application/ld+json"> node (task #119), mirroring the #116 fix
// in components/sections/FaqPage/index.js.
function ProductFaq({ title, ctaV2, faqs }) {
  const allFaqs = useRegionFaqs()
  const faqJsonLdItems = getFaqsForJsonLd(allFaqs, faqs)
  const faqJsonLd = buildFaqJsonLd(faqJsonLdItems)

  return (
    <div className={styles.wrapper}>
      {faqJsonLd && (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
      )}
      <div className={styles.contentWrapper}>
        <div className={styles.leftCol}>
          <div className={styles.leftBox}>
            <SimpleBlockContent
              blocks={title.text}
              highlight={title.highlight}
              highlightSx={`color: ${$neutralGray50};`}
              noSpace
            />
            <CtaV2 {...ctaV2}/>
          </div>
        </div>
        <div className={styles.rightCol}>
          <div className={styles.rightColBox}>
            {
              faqs.map(faq => <FaqCollapsibleList {...faq} key={faq._key}
                sx={{
                  noPadding: true,
                  bgColor: 'transparent',
                  hideTitle: true,
                  textColor: $neutralGray50
                }}
              />)
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductFaq
